
import { DashboardMenu } from "../../data/menu"
import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import changeUrl from "../../hoc/changeur";
import { config } from "../../data/config";
import { motion } from "framer-motion";
import { useTranslation } from 'react-i18next';
import HeaderOfPage from "../tools/headerOfPage";

type LanguageCode = 'ku' | 'fa' | 'en' | 'ar' | 'tr';

interface MultilingualField {
    ku: string;
    fa: string;
    en: string;
    ar: string;
    tr: string;
}

export default function ListPricesGroup() {
    const { t } = useTranslation();
    const [parent, setParent] = useState<any>("");

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Products',
            url: '/dashboard/Products'
        },
        {
            name: 'PriceGroup Group List',
            url: null
        },
    ]
    const reloadgame = () => {
        let x = key + 1;
        setKey(x);
    }
    const setParents = (id: any) => {

        setParent(id);
        let x = key2 + 1;
        setKey2(x);

    }
    
    const [key, setKey] = useState(1);
    const [key2, setKey2] = useState(1);

    return (
        <>
            <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-50 p-4 md:p-6 lg:p-8" dir={t("dir")}>
                <div className="max-w-7xl mx-auto">
                    <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        className="mb-6"
                    >
                        <BreadCrump data={breadcrump}></BreadCrump>
                    </motion.div>
                    
                    <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3, delay: 0.1 }}
                        className="mb-8"
                    >
                        <HeaderOfPage name="Product Price Group List"></HeaderOfPage>
                    </motion.div>

                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
                        <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.4, delay: 0.2 }}
                            className="lg:col-span-4 xl:col-span-3"
                        >
                            <NewGroupCategory parent={parent} key={key2} reloaditem={reloadgame}></NewGroupCategory>
                        </motion.div>
                        
                        <motion.div
                            initial={{ opacity: 0, x: 20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.4, delay: 0.3 }}
                            className="lg:col-span-8 xl:col-span-9"
                        >
                            <ListofBlog setParents={setParents} parent={parent} key={key}></ListofBlog>
                        </motion.div>
                    </div>
                </div>
            </div>

        </>
    )
}
function ListofBlog({ parent, setParents }: any) {
    const { t } = useTranslation();

    let cookie = getCookies();
    const [list, setList] = useState<any>(null);
    const [filteredList, setFilteredList] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<any>(null);
    const [key, setKey] = useState<any>(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');
    const [sortBy, setSortBy] = useState<'name' | 'date'>('name');

    const getalldata = async () => {
        setError(null);
        setLoading(true);

        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/productprice',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            setList(res.data.message);
            setFilteredList(res.data.message);
        } catch (error: any) {
            setError(error.response?.data?.message || t("Failed to load data"));
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: error.response?.data?.message || t("Failed to load price groups")
            });
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        let filtered = list;
        
        if (list && searchQuery) {
            filtered = list.filter((item: any) => {
                const name = typeof item.name === 'string' ? item.name : (item.name?.en || item.name?.fa || item.name?.ku || item.name?.ar || item.name?.tr || '');
                const url = typeof item.url === 'string' ? item.url : (item.url?.en || item.url?.fa || item.url?.ku || item.url?.ar || item.url?.tr || '');
                return name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                       url?.toLowerCase().includes(searchQuery.toLowerCase());
            });
        }
        
        // Sort the filtered list
        if (filtered) {
            filtered = [...filtered].sort((a: any, b: any) => {
                if (sortBy === 'name') {
                    const nameA = typeof a.name === 'string' ? a.name : (a.name?.en || a.name?.fa || a.name?.ku || a.name?.ar || a.name?.tr || '');
                    const nameB = typeof b.name === 'string' ? b.name : (b.name?.en || b.name?.fa || b.name?.ku || b.name?.ar || b.name?.tr || '');
                    return (nameA || '').localeCompare(nameB || '');
                }
                return 0;
            });
        }
        
        setFilteredList(filtered);
    }, [searchQuery, list, sortBy]);
    const getLoadNew = async () => {
        try {
            setParents();
        } finally {
            getalldata();
        }
    }
    const deleted = async (id: String) => {
        Swal.fire({
            title: t("Are you sure?"),
            html: `<div class="text-center">
                <div class="mb-4">
                    <svg class="mx-auto w-16 h-16 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
                    </svg>
                </div>
                <p class="text-lg font-semibold text-gray-800 mb-2">${t("Delete this Group!")}</p>
                <p class="text-sm text-gray-600">${t("This action cannot be undone.")}</p>
            </div>`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ef4444",
            cancelButtonColor: "#6b7280",
            confirmButtonText: `<span class="flex items-center gap-2">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                </svg>
                ${t("Yes, delete it!")}
            </span>`,
            cancelButtonText: `<span class="flex items-center gap-2">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
                ${t("Cancel")}
            </span>`,
            buttonsStyling: true,
            customClass: {
                popup: 'rounded-2xl shadow-2xl border border-gray-200',
                title: 'text-gray-900',
                htmlContainer: 'text-gray-700',
                confirmButton: 'px-6 py-3 rounded-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-200',
                cancelButton: 'px-6 py-3 rounded-lg font-semibold shadow-md hover:shadow-lg transition-all duration-200'
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios({
                        method: 'delete',
                        url: config.url + '/v1/dashboard/productprice/' + id,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        }
                    });

                    Swal.fire({
                        icon: 'success',
                        title: t('Deleted!'),
                        html: `<div class="text-center">
                            <div class="mb-4">
                                <svg class="mx-auto w-16 h-16 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                </svg>
                            </div>
                            <p class="text-lg font-semibold text-gray-800">${t('Price group has been deleted.')}</p>
                        </div>`,
                        timer: 2000,
                        showConfirmButton: false,
                        customClass: {
                            popup: 'rounded-2xl shadow-2xl border border-gray-200',
                            title: 'text-gray-900',
                            htmlContainer: 'text-gray-700'
                        }
                    });
                    getalldata();
                } catch (error: any) {
                    Swal.fire({
                        icon: 'error',
                        title: t('Error'),
                        html: `<div class="text-center">
                            <div class="mb-4">
                                <svg class="mx-auto w-16 h-16 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                </svg>
                            </div>
                            <p class="text-lg font-semibold text-gray-800 mb-2">${t('Error')}</p>
                            <p class="text-sm text-gray-600">${error.response?.data?.message || t("Failed to delete price group")}</p>
                        </div>`,
                        customClass: {
                            popup: 'rounded-2xl shadow-2xl border border-gray-200',
                            title: 'text-gray-900',
                            htmlContainer: 'text-gray-700'
                        }
                    });
                }
            }
        });
    }
    useEffect(() => {
        getalldata();
    }, []);

    if (loading) {
        return (
            <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
                <div className="flex flex-col items-center justify-center py-12">
                    <div className="relative">
                        <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-100 border-t-blue-600"></div>
                        <div className="absolute inset-0 flex items-center justify-center">
                            <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                    </div>
                    <p className="text-center text-gray-600 mt-6 font-semibold text-lg">{t('Loading...')}</p>
                    <p className="text-center text-gray-400 mt-2 text-sm">{t('Please wait while we fetch your data')}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
            {/* Enhanced Header */}
            <div className="px-6 py-6 bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600">
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                    <div className="flex items-center gap-4">
                        <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm shadow-lg">
                            <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <div>
                            <h2 className="text-2xl font-bold text-white">{t('Price Groups')}</h2>
                            {list && list.length > 0 && (
                                <p className="text-blue-100 text-sm mt-1 flex items-center gap-2">
                                    <span className="inline-block w-2 h-2 bg-green-300 rounded-full animate-pulse"></span>
                                    {filteredList?.length || list.length} {filteredList?.length !== list.length ? t('of') + ' ' + list.length : ''} {t('items')}
                                </p>
                            )}
                        </div>
                    </div>
                    {list && list.length > 0 && (
                        <div className="flex flex-wrap items-center gap-3 w-full sm:w-auto">
                            <div className="relative flex-1 sm:flex-initial sm:w-72">
                                <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
                                    <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                    </svg>
                                </div>
                                <input
                                    type="text"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    placeholder={t('Search price groups...')}
                                    className="w-full pl-4 pr-12 py-3 bg-white/95 backdrop-blur-sm border border-white/30 rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-white/70 focus:border-transparent transition-all shadow-lg"
                                />
                            </div>
                            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-lg p-1">
                                <motion.button
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    onClick={() => setViewMode('grid')}
                                    className={`p-2 rounded-lg transition-all ${viewMode === 'grid' ? 'bg-white/20 text-white' : 'text-white/70 hover:bg-white/10'}`}
                                    title={t('Grid view')}
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                                    </svg>
                                </motion.button>
                                <motion.button
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    onClick={() => setViewMode('list')}
                                    className={`p-2 rounded-lg transition-all ${viewMode === 'list' ? 'bg-white/20 text-white' : 'text-white/70 hover:bg-white/10'}`}
                                    title={t('List view')}
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                    </svg>
                                </motion.button>
                            </div>
                            <motion.button
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                onClick={getalldata}
                                className="p-3 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white rounded-lg transition-all shadow-lg"
                                title={t('Refresh')}
                            >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                </svg>
                            </motion.button>
                        </div>
                    )}
                </div>
            </div>

            {/* Error State */}
            {error && (
                <motion.div
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="p-5 bg-red-50 border-l-4 border-red-500 m-6 rounded-lg flex items-start gap-3"
                >
                    <svg className="w-6 h-6 text-red-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <div>
                        <p className="text-red-800 font-semibold">{t('Error')}</p>
                        <p className="text-red-700 text-sm mt-1">{error}</p>
                    </div>
                </motion.div>
            )}

            {/* Empty State */}
            {list && list.length === 0 ? (
                <div className="p-20 text-center">
                    <motion.div
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        transition={{ type: "spring", duration: 0.5 }}
                        className="mx-auto w-24 h-24 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-2xl flex items-center justify-center mb-6 shadow-lg"
                    >
                        <svg className="w-12 h-12 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </motion.div>
                    <h3 className="mt-4 text-xl font-bold text-gray-900">{t('No price groups')}</h3>
                    <p className="mt-3 text-sm text-gray-500 max-w-md mx-auto leading-relaxed">{t('Get started by creating a new price group using the form on the left.')}</p>
                </div>
            ) : filteredList && filteredList.length === 0 ? (
                <div className="p-16 text-center">
                    <motion.div
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        className="mx-auto w-20 h-20 bg-gray-100 rounded-2xl flex items-center justify-center mb-6"
                    >
                        <svg className="h-10 w-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                    </motion.div>
                    <h3 className="mt-4 text-lg font-semibold text-gray-900">{t('No results found')}</h3>
                    <p className="mt-2 text-sm text-gray-500">{t('Try adjusting your search query.')}</p>
                    {searchQuery && (
                        <button
                            onClick={() => setSearchQuery('')}
                            className="mt-4 text-blue-600 hover:text-blue-700 text-sm font-medium"
                        >
                            {t('Clear search')}
                        </button>
                    )}
                </div>
            ) : (
                <div className="p-6">
                    {viewMode === 'grid' ? (
                        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                            {filteredList && filteredList.map((item: any, index: number) => {
                                return (
                                    <motion.div
                                        key={item.id}
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ delay: index * 0.05, duration: 0.3 }}
                                        whileHover={{ y: -4, scale: 1.02 }}
                                        className="group bg-gradient-to-br from-white to-gray-50 rounded-xl border border-gray-200 hover:border-blue-300 shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden"
                                    >
                                        <div className="p-5">
                                            <div className="flex items-start justify-between mb-4">
                                                <div className="flex items-center gap-3 flex-1 min-w-0">
                                                    <div className="w-12 h-12 bg-gradient-to-br from-blue-500 via-indigo-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
                                                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                        </svg>
                                                    </div>
                                                    <div className="flex-1 min-w-0">
                                                        <h3 className="text-base font-bold text-gray-900 truncate group-hover:text-blue-600 transition-colors">
                                                            {typeof item.name === 'string' ? item.name : (item.name?.en || item.name?.fa || item.name?.ku || item.name?.ar || item.name?.tr || t('Unnamed'))}
                                                        </h3>
                                                        <p className="text-xs text-gray-500 mt-1 font-mono bg-gray-100 px-2 py-1 rounded-md inline-block truncate max-w-full">
                                                            /{typeof item.url === 'string' ? item.url : (item.url?.en || item.url?.fa || item.url?.ku || item.url?.ar || item.url?.tr || 'no-slug')}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            {(item.keywords || item.description) && (
                                                <div className="mb-4 pt-4 border-t border-gray-100">
                                                    {item.keywords && (
                                                        <p className="text-xs text-gray-600 line-clamp-2 mb-2">
                                                            <span className="font-semibold">{t('Keywords')}:</span> {typeof item.keywords === 'string' ? item.keywords : (item.keywords?.en || item.keywords?.fa || item.keywords?.ku || item.keywords?.ar || item.keywords?.tr || '')}
                                                        </p>
                                                    )}
                                                    {item.description && (
                                                        <p className="text-xs text-gray-600 line-clamp-2">
                                                            <span className="font-semibold">{t('Description')}:</span> {typeof item.description === 'string' ? item.description : (item.description?.en || item.description?.fa || item.description?.ku || item.description?.ar || item.description?.tr || '')}
                                                        </p>
                                                    )}
                                                </div>
                                            )}
                                            
                                            <div className="flex items-center justify-end gap-2 pt-4 border-t border-gray-100">
                                                <motion.a
                                                    whileHover={{ scale: 1.1, y: -2 }}
                                                    whileTap={{ scale: 0.95 }}
                                                    href={`/dashboard/PriceGroup/${item.id}`}
                                                    className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white rounded-lg shadow-md hover:shadow-lg transition-all duration-200 text-sm font-medium"
                                                    title={t('Edit')}
                                                >
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                    </svg>
                                                    {t('Edit')}
                                                </motion.a>

                                                <motion.button
                                                    whileHover={{ scale: 1.1, y: -2 }}
                                                    whileTap={{ scale: 0.95 }}
                                                    onClick={(e) => { deleted(item.id) }}
                                                    className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-gradient-to-r from-red-500 to-rose-600 hover:from-red-600 hover:to-rose-700 text-white rounded-lg shadow-md hover:shadow-lg transition-all duration-200 text-sm font-medium"
                                                    title={t('Delete')}
                                                >
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                    </svg>
                                                    {t('Delete')}
                                                </motion.button>
                                            </div>
                                        </div>
                                    </motion.div>
                                )
                            })}
                        </div>
                    ) : (
                        <div className="space-y-3">
                            {filteredList && filteredList.map((item: any, index: number) => {
                                return (
                                    <motion.div
                                        key={item.id}
                                        initial={{ opacity: 0, x: -20 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ delay: index * 0.03, duration: 0.3 }}
                                        whileHover={{ x: 4 }}
                                        className="group bg-gradient-to-r from-white to-gray-50 rounded-lg border border-gray-200 hover:border-blue-300 shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden"
                                    >
                                        <div className="p-4 flex items-center justify-between gap-4">
                                            <div className="flex items-center gap-4 flex-1 min-w-0">
                                                <div className="w-10 h-10 bg-gradient-to-br from-blue-500 via-indigo-500 to-purple-600 rounded-lg flex items-center justify-center shadow-md flex-shrink-0">
                                                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                    </svg>
                                                </div>
                                                <div className="flex-1 min-w-0">
                                                    <h3 className="text-base font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                                                        {typeof item.name === 'string' ? item.name : (item.name?.en || item.name?.fa || item.name?.ku || item.name?.ar || item.name?.tr || t('Unnamed'))}
                                                    </h3>
                                                    <p className="text-xs text-gray-500 mt-1 font-mono">
                                                        /{typeof item.url === 'string' ? item.url : (item.url?.en || item.url?.fa || item.url?.ku || item.url?.ar || item.url?.tr || 'no-slug')}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="flex items-center gap-2 flex-shrink-0">
                                                <motion.a
                                                    whileHover={{ scale: 1.05 }}
                                                    whileTap={{ scale: 0.95 }}
                                                    href={`/dashboard/PriceGroup/${item.id}`}
                                                    className="inline-flex items-center justify-center gap-2 px-3 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg shadow-sm hover:shadow transition-all duration-200 text-sm font-medium"
                                                    title={t('Edit')}
                                                >
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                    </svg>
                                                    {t('Edit')}
                                                </motion.a>
                                                <motion.button
                                                    whileHover={{ scale: 1.05 }}
                                                    whileTap={{ scale: 0.95 }}
                                                    onClick={(e) => { deleted(item.id) }}
                                                    className="inline-flex items-center justify-center gap-2 px-3 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg shadow-sm hover:shadow transition-all duration-200 text-sm font-medium"
                                                    title={t('Delete')}
                                                >
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                    </svg>
                                                    {t('Delete')}
                                                </motion.button>
                                            </div>
                                        </div>
                                    </motion.div>
                                )
                            })}
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}
function NewGroupCategory({ parent, reloaditem }: any) {
    const { t } = useTranslation();

    let cookie = getCookies();
    const [data, setData] = useState<any>({
        name: { ku: '', fa: '', en: '', ar: '', tr: '' },
        url: { ku: '', fa: '', en: '', ar: '', tr: '' },
        keywords: { ku: '', fa: '', en: '', ar: '', tr: '' },
        description: { ku: '', fa: '', en: '', ar: '', tr: '' },
        parent: parent
    });
    const [error, setError] = useState<any>(null);
    const [key, setKey] = useState(1);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [activeLang, setActiveLang] = useState<LanguageCode>('en');

    const languages: Array<{ code: LanguageCode; label: string }> = [
        { code: 'ku' as LanguageCode, label: 'Kurdish' },
        { code: 'fa' as LanguageCode, label: 'فارسی' },
        { code: 'en' as LanguageCode, label: 'English' },
        { code: 'ar' as LanguageCode, label: 'العربية' },
        { code: 'tr' as LanguageCode, label: 'Türkçe' }
    ];

    // Helper function to safely access multilingual fields
    const getMultilingualValue = (field: any, lang: LanguageCode): string => {
        if (!field) return '';
        if (typeof field === 'string') return field; // Legacy support
        if (typeof field === 'object' && field !== null && !Array.isArray(field)) {
            return field[lang] || field.en || field.fa || field.ku || field.ar || field.tr || '';
        }
        return '';
    };

    const setName = (name: string) => {
        const updatedName = { 
            ...data.name, 
            [activeLang]: name 
        };
        
        // Generate slug for the active language when typing
        const updatedUrl = { ...data.url };
        updatedUrl[activeLang] = String(changeUrl(name));
        
        setData((prev: any) => ({ 
            ...prev, 
            url: updatedUrl, 
            name: updatedName
        }));
    }

    const save = async () => {
        const currentName = getMultilingualValue(data.name, activeLang);
        const currentUrl = getMultilingualValue(data.url, activeLang);
        
        if (!currentName || !currentUrl) {
            Swal.fire({
                icon: 'warning',
                title: t('Validation Error'),
                html: `<div class="text-center">
                    <div class="mb-4">
                        <svg class="mx-auto w-16 h-16 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
                        </svg>
                    </div>
                    <p class="text-lg font-semibold text-gray-800 mb-2">${t('Validation Error')}</p>
                    <p class="text-sm text-gray-600">${t('Please fill in all required fields')}</p>
                </div>`,
                timer: 2500,
                showConfirmButton: false,
                customClass: {
                    popup: 'rounded-2xl shadow-2xl border border-gray-200',
                    title: 'text-gray-900',
                    htmlContainer: 'text-gray-700'
                }
            });
            return;
        }

        setError(null);
        setLoading(true);
        setSuccess(false);
        
        try {
            let res = await axios({
                method: 'post',
                url: config.url + '/v1/dashboard/productprice',
                data: data,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            Swal.fire({
                icon: 'success',
                title: t('Success!'),
                html: `<div class="text-center">
                    <div class="mb-4">
                        <svg class="mx-auto w-16 h-16 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        </svg>
                    </div>
                    <p class="text-lg font-semibold text-gray-800 mb-2">${t('Success!')}</p>
                    <p class="text-sm text-gray-600">${t('Price group created successfully')}</p>
                </div>`,
                timer: 2500,
                showConfirmButton: false,
                customClass: {
                    popup: 'rounded-2xl shadow-2xl border border-gray-200',
                    title: 'text-gray-900',
                    htmlContainer: 'text-gray-700'
                }
            });

            setData({
                name: { ku: '', fa: '', en: '', ar: '', tr: '' },
                url: { ku: '', fa: '', en: '', ar: '', tr: '' },
                keywords: { ku: '', fa: '', en: '', ar: '', tr: '' },
                description: { ku: '', fa: '', en: '', ar: '', tr: '' },
                parent: parent
            });
            setSuccess(true);
            reloaditem();
            let x = key + 1;
            setKey(x);
            
            setTimeout(() => setSuccess(false), 3000);
        } catch (error: any) {
            setError(error.response?.data?.message || t('Failed to create price group'));
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                html: `<div class="text-center">
                    <div class="mb-4">
                        <svg class="mx-auto w-16 h-16 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        </svg>
                    </div>
                    <p class="text-lg font-semibold text-gray-800 mb-2">${t('Error')}</p>
                    <p class="text-sm text-gray-600">${error.response?.data?.message || t('Failed to create price group')}</p>
                </div>`,
                customClass: {
                    popup: 'rounded-2xl shadow-2xl border border-gray-200',
                    title: 'text-gray-900',
                    htmlContainer: 'text-gray-700'
                }
            });
        } finally {
            setLoading(false);
        }
    }

    const inputstyle = "w-full px-4 py-3 border-2 border-gray-200 rounded-xl text-sm text-gray-900 bg-white focus:outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-500 transition-all duration-200 placeholder-gray-400 hover:border-gray-300 shadow-sm hover:shadow-md focus:shadow-lg";
    const labelStyle = "flex items-center gap-1 text-sm font-semibold text-gray-700 mb-2.5";
    
    return (
        <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100 sticky top-4"
        >
            <div className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 px-6 py-4">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center backdrop-blur-sm shadow-md">
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                        </svg>
                    </div>
                    <div>
                        <h4 className="text-white text-lg font-bold">{t('جدید')} / {t('New')}</h4>
                        <p className="text-blue-100 text-xs mt-0.5">{t('Create new price group')}</p>
                    </div>
                </div>
            </div>

            <form key={key} className="p-6 space-y-5" dir={t("dir")}>
                {success && (
                    <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        className="p-3 bg-green-50 border border-green-200 rounded-lg flex items-center gap-2"
                    >
                        <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        <span className="text-sm text-green-700 font-medium">{t('Price group created successfully!')}</span>
                    </motion.div>
                )}

                {/* Language Selector */}
                {languages && languages.length > 0 && (
                    <div className="mb-4 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border border-blue-200">
                        <label className="flex items-center gap-2 text-sm font-semibold text-gray-800 mb-3">
                            <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
                            </svg>
                            {t('Language')} / زبان
                        </label>
                        <div className="flex gap-2 flex-wrap">
                            {languages.map((lang) => (
                                <motion.button
                                    key={lang.code}
                                    type="button"
                                    onClick={() => setActiveLang(lang.code)}
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    className={`px-4 py-2.5 text-sm font-semibold rounded-lg transition-all duration-200 ${
                                        activeLang === lang.code
                                            ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg ring-2 ring-blue-300'
                                            : 'bg-white text-gray-700 hover:bg-gray-50 shadow-md border border-gray-200 hover:border-blue-300'
                                    }`}
                                >
                                    {lang.label}
                                </motion.button>
                            ))}
                        </div>
                    </div>
                )}

                <div>
                    <label className={labelStyle}>
                        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                        </svg>
                        {t('Name')} ({languages.find(l => l.code === activeLang)?.label}) <span className="text-red-500 font-bold">*</span>
                    </label>
                    <div className="relative group">
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                            <svg className="w-5 h-5 text-gray-400 group-focus-within:text-blue-500 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                            </svg>
                        </div>
                        <input
                            type="text"
                            value={getMultilingualValue(data.name, activeLang)}
                            className={`${inputstyle} pr-10 ${error && error['name'] ? 'border-red-400 bg-red-50 focus:ring-red-200 focus:border-red-500' : ''} ${getMultilingualValue(data.name, activeLang) && !error ? 'border-green-400 pr-12' : ''}`}
                            placeholder={t('Enter price group name')}
                            onChange={(e) => { setName(e.target.value); }}
                        />
                        {getMultilingualValue(data.name, activeLang) && !error && (
                            <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none animate-in fade-in duration-200">
                                <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                        )}
                    </div>
                    {error && error['name'] && (
                        <motion.p 
                            initial={{ opacity: 0, y: -5 }}
                            animate={{ opacity: 1, y: 0 }}
                            className="mt-2 text-xs text-red-600 flex items-center gap-1.5 bg-red-50 px-3 py-2 rounded-lg border border-red-200"
                        >
                            <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                            <span>{error['name']['message']}</span>
                        </motion.p>
                    )}
                </div>

                <div>
                    <label className={labelStyle}>
                        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                        </svg>
                        {t('Slug')} ({languages.find(l => l.code === activeLang)?.label}) <span className="text-red-500 font-bold">*</span>
                    </label>
                    <div className="relative group">
                        <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 text-sm font-medium group-focus-within:text-blue-500 transition-colors">/</span>
                        <input
                            type="text"
                            value={getMultilingualValue(data.url, activeLang)}
                            className={`${inputstyle} ${error && error['url'] ? 'border-red-400 bg-red-50 focus:ring-red-200 focus:border-red-500' : ''} ${getMultilingualValue(data.url, activeLang) && !error ? 'border-green-400 pl-8 pr-12' : 'pl-8'} ${!getMultilingualValue(data.url, activeLang) ? 'pl-8' : ''}`}
                            placeholder={t('URL slug (auto-generated)')}
                            onChange={(e) => setData({ ...data, url: { ...data.url, [activeLang]: e.target.value } })}
                        />
                        {getMultilingualValue(data.url, activeLang) && !error && (
                            <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none animate-in fade-in duration-200">
                                <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                        )}
                    </div>
                    {error && error['url'] && (
                        <motion.p 
                            initial={{ opacity: 0, y: -5 }}
                            animate={{ opacity: 1, y: 0 }}
                            className="mt-2 text-xs text-red-600 flex items-center gap-1.5 bg-red-50 px-3 py-2 rounded-lg border border-red-200"
                        >
                            <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                            <span>{error['url']['message']}</span>
                        </motion.p>
                    )}
                </div>

                <div>
                    <label className={labelStyle}>
                        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                        </svg>
                        {t('Keywords')} ({languages.find(l => l.code === activeLang)?.label})
                    </label>
                    <textarea
                        value={getMultilingualValue(data.keywords, activeLang)}
                        rows={3}
                        className={`${inputstyle} resize-none`}
                        onChange={(e) => setData({ ...data, keywords: { ...data.keywords, [activeLang]: e.target.value } })}
                        placeholder={t('Enter keywords (optional)')}
                    />
                </div>

                <div>
                    <label className={labelStyle}>
                        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h7" />
                        </svg>
                        {t('Description')} ({languages.find(l => l.code === activeLang)?.label})
                    </label>
                    <textarea
                        value={getMultilingualValue(data.description, activeLang)}
                        rows={3}
                        className={`${inputstyle} resize-none`}
                        onChange={(e) => setData({ ...data, description: { ...data.description, [activeLang]: e.target.value } })}
                        placeholder={t('Enter description (optional)')}
                    />
                </div>

                <motion.button
                    type="button"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={(e) => { save() }}
                    disabled={loading || !getMultilingualValue(data.name, activeLang) || !getMultilingualValue(data.url, activeLang)}
                    className="w-full py-3 px-4 inline-flex items-center justify-center gap-2 text-sm font-semibold rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white shadow-md hover:shadow-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:shadow-md"
                >
                    {loading ? (
                        <>
                            <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                            <span>{t('Creating...')}</span>
                        </>
                    ) : (
                        <>
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                            </svg>
                            <span>{t('Add Category')}</span>
                        </>
                    )}
                </motion.button>
                {(!getMultilingualValue(data.name, activeLang) || !getMultilingualValue(data.url, activeLang)) && (
                    <p className="text-xs text-gray-500 text-center mt-2">
                        {t('Fill in required fields to enable')}
                    </p>
                )}
            </form>
        </motion.div>
    )
}